import { render, staticRenderFns } from "./VCommentsAppendixQuestion.vue?vue&type=template&id=e0a51c44&scoped=true&"
import script from "./VCommentsAppendixQuestion.vue?vue&type=script&lang=js&"
export * from "./VCommentsAppendixQuestion.vue?vue&type=script&lang=js&"
import style0 from "./VCommentsAppendixQuestion.vue?vue&type=style&index=0&id=e0a51c44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a51c44",
  null
  
)

export default component.exports